import React from 'react';
import { useContext } from 'react';
import SimpleContext from './../context/SimpleContext';

const Date = () => {

  const context = useContext(SimpleContext);
  const date = context.tarikh;
  return ( 
    <React.Fragment>
      <p className="tarikh">{`${date}`}</p>
          
    </React.Fragment>
    );
  }
    
    export default Date;


    // const HandelShowContentPage = (num)=>{
  
    //   let contentmonthValue = num;
      
    //   let monthContent = "";
    //   switch(contentmonthValue){
    //     case '01':
    //       monthContent = "فروردین"
    //       break;
    //       case '02':
    //       monthContent = "اردیبهشت"
    //       break;
    //       case '03':
    //       monthContent = "خرداد"
    //       break;
    //       case '04':
    //       monthContent = "تیر"
    //       break;
    //       case '05':
    //       monthContent = "مرداد"
    //       break;
    //       case '06':
    //       monthContent = "شهریور"
    //       break;
    //       case '07':
    //       monthContent = "مهر"
    //       break;
    //       case '08':
    //       monthContent = "آبان"
    //       break;
    //       case '09':
    //       monthContent = "آذر"
    //       break;
    //       case '10':
    //       monthContent = "دی"
    //       break;
    //       case '11':
    //       monthContent = "بهمن"
    //       break;
    //       case '12':
    //       monthContent = "اسفند"
    //       break;
    //     }
    //   };


    // {
    //   Object.keys(date).map(key => 
    //     <ShowDate 
    //     tarikh={date[key]}
    //     />
    //     )}
    